var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "update",
    transform: "translate(-491 -223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 60,
    height: 60,
    rx: 5,
    transform: "translate(491 223)",
    fill: "#f4f5fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_login_rounded_up",
    d: "M22,4a18,18,0,0,0-6.325,34.857,1.35,1.35,0,1,0,.949-2.528,15.3,15.3,0,1,1,10.751,0,1.35,1.35,0,1,0,.949,2.528A18,18,0,0,0,22,4Zm-.019,11.7a1.35,1.35,0,0,0-.935.4l-5.4,5.4A1.35,1.35,0,1,0,17.554,23.4l3.1-3.1.016,18.345a1.35,1.35,0,1,0,2.7,0l-.016-18.338L26.446,23.4A1.35,1.35,0,1,0,28.354,21.5l-5.4-5.4a1.35,1.35,0,0,0-.974-.4Z",
    transform: "translate(499 231)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.024733d29e72f2be82575b8aa943ea11.svg";
export { ForwardRef as ReactComponent };